module.exports = __webpack_public_path__ + "img/nav-Script-Blue.97b7bfb3.png";